import { cn } from '../../lib/cn';

interface AvatarProps {
  src?: string | null;
  alt?: string;
  name?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  ring?: boolean;
  ringColor?: string;
}

const sizes = {
  xs: 'h-6 w-6 text-[10px]',
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-14 w-14 text-lg',
  xl: 'h-20 w-20 text-2xl',
};

function getInitials(name?: string): string {
  if (!name) return '?';
  return name
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

const palette = [
  'bg-capsule-purple', 'bg-sunrise-coral', 'bg-golden-hour',
  'bg-mint-fresh', 'bg-twilight-blue', 'bg-deep-indigo',
];

function colorFromName(name?: string): string {
  if (!name) return palette[0];
  const hash = name.split('').reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  return palette[hash % palette.length];
}

export function Avatar({ src, alt, name, size = 'md', className, ring, ringColor }: AvatarProps) {
  return (
    <div
      className={cn(
        'relative inline-flex items-center justify-center rounded-full overflow-hidden shrink-0',
        sizes[size],
        ring && 'ring-2 ring-offset-2 ring-offset-white dark:ring-offset-dark-bg',
        ring && (ringColor || 'ring-capsule-purple'),
        className
      )}
    >
      {src ? (
        <img src={src} alt={alt || name || 'Avatar'} className="h-full w-full object-cover" />
      ) : (
        <div
          className={cn(
            'h-full w-full flex items-center justify-center font-medium text-white',
            colorFromName(name)
          )}
        >
          {getInitials(name)}
        </div>
      )}
    </div>
  );
}
